export const Tags = {
  TOPICS: '@@cotera-topics',
  TOPIC: '@@cotera-topic',
  DECISON_TREE: '@@cotera-decision-tree',
  EXPR_COLUMN: '@@cotera-eraql-column',
  UDD: '@@cotera-udd',
  PENDING: '@@cotera-pending',
};
